import { createSelector } from 'reselect'

const activitiesSelector = state => state.game.activities.filter(activity => activity.state !== 'deleting')

export default createSelector(
	[ activitiesSelector],
	activities => activities
)
